export type Quadrant = 'do' | 'schedule' | 'delegate' | 'eliminate';

export const QUADRANTS: Quadrant[] = ['do', 'schedule', 'delegate', 'eliminate'];

export const QUADRANT_LABELS: Record<Quadrant, { title: string; subtitle: string }> = {
  do:        { title: 'Do',        subtitle: 'Urgent & Important' },
  schedule:  { title: 'Schedule',  subtitle: 'Not Urgent & Important' },
  delegate:  { title: 'Delegate',  subtitle: 'Urgent & Not Important' },
  eliminate: { title: 'Eliminate', subtitle: 'Not Urgent & Not Important' },
};

export interface Task {
  id: string;
  owner_id: string;
  quadrant: Quadrant;
  title: string;
  notes: string | null;
  position: number;
  created_at: string;
  updated_at: string;
}

export type AuthRole = 'owner' | 'viewer' | 'none';

export interface AuthState {
  role: AuthRole;
  email: string | null;
  ownerIdForViewer: string | null;  // set when role === 'viewer'
  loading: boolean;
}

export interface ViewerToken {
  id: string;
  label: string | null;
  expires_at: string;
  created_at: string;
  revoked_at: string | null;
}
